import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import { FOLDER_SIDEBAR_WIDTH } from 'framework-listing-lib/constants/folders';
import { DEFAULT_PADDING_TOKEN } from 'framework-listing-lib/constants/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FilterErrorComponent() {
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "warning",
      size: "xxs"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkListingLib.error.filtersError.message"
    })]
  });
}
const Toolbar = styled.div.withConfig({
  displayName: "CrmListingFilterBar__Toolbar",
  componentId: "r13vfq-0"
})(({
  theme,
  $hasViews,
  $isFoldersTabActive,
  $isFoldersMode
}) => `
  padding: 0;
  padding-block-start: ${theme.space['300']};
  padding-inline-start: ${theme.space['300']};
  padding-inline-end: ${$hasViews && `${theme.space['300']}`};
  margin-inline: 0;
  margin-block-end: 0;
  margin-block-start: 0;

  border-inline-start: ${$hasViews && !$isFoldersTabActive && `${theme.borderWidth['100']} solid ${theme.color['border-core-default']}`};
  border-inline-end: ${$hasViews && `${theme.borderWidth['100']} solid ${theme.color['border-core-default']}`};

  position: relative;
  z-index: 10;

  ${($isFoldersTabActive || $isFoldersMode) && `padding-inline-start: ${theme.space['600']};
    margin-inline-start: ${FOLDER_SIDEBAR_WIDTH}px;
    width: calc(100% - ${FOLDER_SIDEBAR_WIDTH}px);`}

  ${!$isFoldersTabActive && `width: 100%`}
`);
const ToolbarInner = styled.div.withConfig({
  displayName: "CrmListingFilterBar__ToolbarInner",
  componentId: "r13vfq-1"
})(({
  theme,
  $hasViews
}) => `
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0;
  margin-block-start: -${theme.space[DEFAULT_PADDING_TOKEN]};
  margin-inline-start: -${theme.space[DEFAULT_PADDING_TOKEN]};


  padding-block-end: ${theme.space[DEFAULT_PADDING_TOKEN]};
  padding-block-start: ${$hasViews && theme.space[DEFAULT_PADDING_TOKEN]};

  > * + * {
    margin-inline-start: ${theme.space[DEFAULT_PADDING_TOKEN]};
  }
`);

// This style was originally on SlotFlexContainer
// TODO: do we need it?
/* regrettable. too risky to apply to .private-button defaults */
// > .private-button.private-button {
//   flex-shrink: 0;
//   margin-top: 0;
//   width: auto;
// }
const SlotFlexContainer = styled.div.withConfig({
  displayName: "CrmListingFilterBar__SlotFlexContainer",
  componentId: "r13vfq-2"
})(["align-items:center;display:flex;flex-shrink:0;> * + *{margin-inline-start:", ";}"], ({
  theme
}) => theme.space['300']);
const StartSlot = styled(SlotFlexContainer).withConfig({
  displayName: "CrmListingFilterBar__StartSlot",
  componentId: "r13vfq-3"
})(["justify-content:flex-start;flex-grow:1;", ""], ({
  $scrollable
}) => $scrollable && `
      flex-shrink: 1;
      overflow-x: auto;
    `);
const EndSlot = styled(SlotFlexContainer).withConfig({
  displayName: "CrmListingFilterBar__EndSlot",
  componentId: "r13vfq-4"
})(["justify-content:flex-end;"]);
export const CrmListingFilterBar = props => {
  const {
    'data-test-id': dataTestId,
    endSlot,
    startSlot,
    hasViews,
    isFoldersTabActive,
    isFoldersMode,
    scrollable
  } = props;
  return /*#__PURE__*/_jsx(Toolbar, {
    role: "group",
    $hasViews: hasViews,
    $isFoldersTabActive: isFoldersTabActive,
    $isFoldersMode: isFoldersMode,
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsxs(ToolbarInner, {
      $hasViews: hasViews,
      children: [startSlot ?
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(StartSlot, {
        $scrollable: scrollable,
        children: startSlot
      }) : null, endSlot ? /*#__PURE__*/_jsx(EndSlot, {
        children: endSlot
      }) : null]
    })
  });
};